import { isEmpty } from "lodash";
import { LOCAL_SANCTIONS_URL } from "./const";

export function getSanctionsUrl() {
  const REACT_ENV = import.meta.env.VITE_HOST_ENV;
  const SANCTIONS_URL = !!import.meta.env.VITE_SANCTIONS_URL && import.meta.env.VITE_SANCTIONS_URL !== "" ? import.meta.env.VITE_SANCTIONS_URL : LOCAL_SANCTIONS_URL;
  if (!isEmpty(REACT_ENV)) {
    return SANCTIONS_URL;
  } else {
    return LOCAL_SANCTIONS_URL;
  }
}
